<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
let timeout__windowresize
export default {
  name: 'App',
  methods: {
    renderResize() {
      let width = document.documentElement.clientWidth
      let isMobile = (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
      if (width > 400 && !isMobile) {
        document.documentElement.style.maxWidth = '400px'
      }
    },
  },
  mounted(){
    this.renderResize()
    window.addEventListener("resize", this.renderResize, false)
    // 浏览器变化时 改变页面布局
    window.onresize = () => {
      timeout__windowresize && clearTimeout(timeout__windowresize)
      timeout__windowresize = setTimeout(() => {
        this.renderResize()
      }, 300)
    }
    window.onload = function() {
      // 阻止双击放大
      var lastTouchEnd = 0
      document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('touchend', function(event) {
        var now = (new Date()).getTime()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      }, false)
      // 阻止双指放大
      document.addEventListener('gesturestart', function(event) {
        event.preventDefault()
      })
    }
  }
}

</script>

<style>
html {
  height: 100%;
  margin: 0 auto;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue